export default {
	customerDetails: {}
};
